import React, { useLayoutEffect } from "react";
import { ContentContainer } from "../../../components/layout";
import {
	Button,
	CheckboxList,
	EmptyModal,
	LinearProgressBar,
	Modal,
	MultiSelect,
	NoDataFoundTemplate,
	RadioButtonList,
	Select,
} from "../../../components/core";
import {
	useApolloClient,
	useLazyQuery,
	useMutation,
	useQuery,
} from "@apollo/client";
import {
	ADD_PARTNER_AGENT_ASSIGNMENT,
	ADD_PARTNER_BRANCH_ASSIGNMENT,
	DELETE_PARTNER_AGENT_ASSIGNMENT,
	DELETE_PARTNER_BRANCH_ASSIGNMENT,
	GET_AGENTS_BY_PARTNER_AND_BRANCH,
	GET_PARTNERS_WITH_OR_WITHOUT_ID,
	LOCKER_TYPES,
	PARTNER_AGENT_ASSIGNMENT_BY_LOCKERS,
	PARTNER_BRANCH_ASSIGNMENT_BY_UNASSIGNED_LOCKERS,
	PARTNER_BRANCH_ASSIGNMENTS_BY_ASSIGNED_BRANCHES,
} from "../../../constants/graphql/locker-queries";
import { useDispatch, useSelector } from "react-redux";
import {
	clearSearchData,
	getAgentList,
	getLockerTypeList,
	getPartnerList,
	getpPartnerAgentAssignmentsByLockers,
	handleAddPartnerAgentAssignmentData,
	handleOnChanged,
} from "../../../features/assign-to-agent/assign-to-agent-slice";
import { BRANCHES } from "../../../constants/graphql/partner-agent-queries";
import OutputTable from "./components/output-table";
import { getBranchList } from "../../../features/assign-to-agent/assign-to-agent-slice";
import { Dialog } from "primereact/dialog";
import VerticalRadioButtonList from "./components/vertical-radiobutton-list";
import VerticalCheckboxList from "./components/vertical-checkbox-list";

export default function AssignToAgents() {
	const accessPermission = useSelector(
		(state) => state.accessPermissions.accessPermissions
	);
	const client = useApolloClient();
	const dispatch = useDispatch();
	const searchData = useSelector((state) => state.assignToAgents.searchData);
	const partnerList = useSelector((state) => state.assignToAgents.partnerList);
	const branchList = useSelector((state) => state.assignToAgents.branchList);
	const agentList = useSelector((state) => state.assignToAgents.agentList);
	const addPartnerAgentAssignmentData = useSelector(
		(state) => state.assignToAgents.addPartnerAgentAssignmentData
	);
	const partnerAgentAssignmentsByLockersData = useSelector(
		(state) => state.assignToAgents.partnerAgentAssignmentsByLockersData
	);
	const lockerTypeList = useSelector(
		(state) => state.assignToAgents.lockerTypeList
	);
	const lockerTypes = useQuery(LOCKER_TYPES);
	const [getAgentsByPartnerAndBranch] = useLazyQuery(
		GET_AGENTS_BY_PARTNER_AND_BRANCH
	);
	const searchPartners = useQuery(GET_PARTNERS_WITH_OR_WITHOUT_ID, {
		variables: {
			operatorId: localStorage.getItem("user")
				? JSON.parse(localStorage.getItem("user")).operator_id
				: "",
		},
	});
	const [partnerAgentAssignmentByLockers] = useLazyQuery(
		PARTNER_AGENT_ASSIGNMENT_BY_LOCKERS
	);
	const partnerAgentAssignmentByLockersQuery = useQuery(
		PARTNER_AGENT_ASSIGNMENT_BY_LOCKERS
	);
	const branches = useQuery(BRANCHES, {
		variables: {
			operatorId: localStorage.getItem("user")
				? JSON.parse(localStorage.getItem("user")).operator_id
				: "",
		},
	});
	const [branchesLazy] = useLazyQuery(BRANCHES);
	const [addPartnerAgentAssignment] = useMutation(ADD_PARTNER_AGENT_ASSIGNMENT);
	const [deletePartnerAgentAssignment] = useMutation(
		DELETE_PARTNER_AGENT_ASSIGNMENT
	);
	const [addAgentValidation, setAddAgentValidation] = React.useState(false);
	const [onLoad, setOnLoad] = React.useState(false);
	const [validation, setValidation] = React.useState({
		icon: `${process.env.PUBLIC_URL}/assets/images/error.png`,
		title: "Invalid data",
		message: "",
		open: false,
	});
	const [errorValidation, setErrorValidation] = React.useState({
		icon: `${process.env.PUBLIC_URL}/assets/images/error.png`,
		title: "Invalid data",
		message: "",
		open: false,
	});
	const [searchFlag, setSearchFlag] = React.useState(false);
	const [addAgentModal, setAddAgentModal] = React.useState(false);
	React.useEffect(() => {
		dispatch(clearSearchData());
	}, []);
	React.useEffect(() => {
		if (lockerTypes.data) {
			let tempData = [];
			lockerTypes.data.lockerTypes.forEach((element) => {
				tempData.push({
					value: element.lockerTypeId,
					name: element.lockerType,
				});
			});
			dispatch(getLockerTypeList(tempData));
		}
	}, [lockerTypes.data]);
	React.useEffect(() => {
		if (searchPartners.data) {
			let tempData = [];
			searchPartners.data.partners.forEach((element) => {
				tempData.push({
					value: element.partnerId,
					name: element.companyNickname,
				});
			});
			dispatch(getPartnerList(tempData));
		}
	}, [searchPartners.data]);
	React.useEffect(() => {
		if (branches.data) {
			let tempData = [];
			branches.data.partnerBranches.forEach((element) => {
				tempData.push({
					value: element.partnerBranchId,
					name: element.partnerBranch,
				});
			});
			dispatch(getBranchList(tempData));
		}
	}, [branches.data]);
	const handleSearchParnerAgentAssignment = () => {
		if (
			searchData.lockerTypeId === "-1" ||
			searchData.partnerBranchId === "-1" ||
			searchData.partnerId === "-1"
		) {
			setErrorValidation({
				icon: `${process.env.PUBLIC_URL}/assets/images/error.png`,
				title: "Incomplete search criteria",
				message: "Partner, Branch and Locker Type are required.",
				open: true,
			});
		} else {
			setSearchFlag(true);
			setOnLoad(true);
			partnerAgentAssignmentByLockers({ variables: searchData }).then(
				(data) => {
					console.log(data.data);
					if (data.data) {
						let tempArr = [];
						data.data.partnerAgentAssignmentsByLockers.forEach((element) => {
							console.log(element);
						});
						dispatch(
							getpPartnerAgentAssignmentsByLockers(
								data.data.partnerAgentAssignmentsByLockers
							)
						);
						setOnLoad(false);
					} else {
						setOnLoad(false);
					}
				}
			);
		}
	};
	const handleOnChange = (event) => {
		const { name, value } = event.target;
		console.log(name);
		if (name === "partnerId") {
			let tempVar = {
				operatorId: localStorage.getItem("user")
					? JSON.parse(localStorage.getItem("user")).operator_id
					: "",
				partnerId: value,
			};

			if (value === "-1") {
				delete tempVar.partnerId;
				branches.refetch(tempVar).then((data) => {
					if (data.data) {
						console.log(data.data);
						let tempData = [];
						data.data.partnerBranches.forEach((element) => {
							tempData.push({
								value: element.partnerBranchId,
								name: element.partnerBranch,
							});
						});
						dispatch(getBranchList(tempData));
					}
				});
			}
			console.log(tempVar);
			branchesLazy({ variables: tempVar }).then((data) => {
				if (data.data) {
					console.log(data.data);
					let tempData = [];
					data.data.partnerBranches.forEach((element) => {
						tempData.push({
							value: element.partnerBranchId,
							name: element.partnerBranch,
						});
					});
					dispatch(getBranchList(tempData));
				}
			});
		}
		setSearchFlag(false);
		dispatch(handleOnChanged({ name: name, value: value }));
	};
	const handleDeleteAgentAssignment = () => {
		deletePartnerAgentAssignment({
			variables: {
				operatorId: localStorage.getItem("user")
					? JSON.parse(localStorage.getItem("user")).operator_id
					: "",
				partnerAgentAssignmentId: validation.header.partnerAgentAssignmentId,
			},
		}).then((data) => {
			partnerAgentAssignmentByLockersQuery.refetch(searchData).then((data) => {
				if (data.data.partnerAgentAssignmentsByLockers) {
					dispatch(
						getpPartnerAgentAssignmentsByLockers(
							data.data.partnerAgentAssignmentsByLockers
						)
					);
					setValidation((prev) => ({
						...prev,
						open: false,
					}));
					setErrorValidation({
						icon: `${process.env.PUBLIC_URL}/assets/images/check.png`,
						title: "Success",
						message: "Successfully unassigned agent.",
						open: true,
					});
				}
			});
		});
		client.clearStore();
	};
	const handleAddPartnerAgentAssignment = () => {
		if (addPartnerAgentAssignmentData.partnerAgentId.length > 0) {
			addPartnerAgentAssignmentData.partnerAgentId.forEach((element) => {
				let tempAddPartnerAgentAssignmentData = {
					...addPartnerAgentAssignmentData,
				};
				tempAddPartnerAgentAssignmentData.partnerAgentId = element.id;
				addPartnerAgentAssignment({
					variables: tempAddPartnerAgentAssignmentData,
				}).then((data) => {
					partnerAgentAssignmentByLockersQuery
						.refetch(searchData)
						.then((data) => {
							if (data.data.partnerAgentAssignmentsByLockers) {
								dispatch(
									getpPartnerAgentAssignmentsByLockers(
										data.data.partnerAgentAssignmentsByLockers
									)
								);
								setAddAgentModal(false);
								setErrorValidation({
									icon: `${process.env.PUBLIC_URL}/assets/images/check.png`,
									title: "Success",
									message: "Successfully assigned agent.",
									open: true,
								});
								setAddAgentValidation(false);
							}
						});
				});
			});
		} else {
			setAddAgentValidation(true);
		}
	};

	console.log({ searchData });
	return (
		<ContentContainer containerTitle={"Assign to Agent"}>
			<div className="w-4/5 grid grid-cols-5 gap-2">
				<div className="col-span-1">
					<p className="text-base mt-2">Partner: </p>
				</div>
				<div className="bg-slate-50 col-span-3">
					<Select
						value={searchData.partnerId}
						items={partnerList}
						defaultOption={{ value: "-1", name: "-- Select a Partner--" }}
						onChange={handleOnChange}
						name="partnerId"
					/>
				</div>
				<div className="col-span-1"></div>
				<div className="col-span-1">
					<p className="text-base mt-2">Branch: </p>
				</div>
				<div className="bg-slate-50 col-span-3">
					<Select
						value={searchData.partnerBranchId}
						items={branchList}
						defaultOption={{ value: "-1", name: "-- Select a Branch--" }}
						onChange={handleOnChange}
						name="partnerBranchId"
					/>
				</div>
				<div className="col-span-1"></div>
				<div className="col-span-1">
					<p className="text-base mt-2">Locker Type: </p>
				</div>
				<div className="bg-slate-50 col-span-3">
					<Select
						value={searchData.lockerTypeId}
						items={lockerTypeList}
						defaultOption={{ value: "-1", name: "-- Select Locker Type --" }}
						onChange={handleOnChange}
						name="lockerTypeId"
					/>
				</div>
				<div className="col-span-1 flex">
					<Button
						onClick={handleSearchParnerAgentAssignment}
						className={"w-full h-full mr-2"}
						value="Search"
					/>
				</div>
			</div>
			<hr className="mt-4"></hr>
			{onLoad && <LinearProgressBar label="" open={onLoad} />}
			{!onLoad &&
				searchFlag &&
				partnerAgentAssignmentsByLockersData.length === 0 && (
					<NoDataFoundTemplate width={56} height={56} />
				)}
			{searchFlag ? (
				partnerAgentAssignmentsByLockersData.length > 0 &&
				!onLoad && (
					<OutputTable
						disabled={
							accessPermission.assignToAgent === 1 ||
							accessPermission.assignToAgent === "1"
						}
						partner={
							partnerList.find((x) => x.value === searchData.partnerId) &&
							partnerList.find((x) => x.value === searchData.partnerId).name
						}
						branch={
							branchList.find((x) => x.value === searchData.partnerBranchId) &&
							branchList.find((x) => x.value === searchData.partnerBranchId)
								.name
						}
						lockerType={
							lockerTypeList.find((x) => x.value === searchData.lockerTypeId) &&
							lockerTypeList.find((x) => x.value === searchData.lockerTypeId)
								.name
						}
						headers={[
							{
								header_name: "Lockers",
								header_key: "lockerName",
							},
							{
								header_name: "Agents",
								header_key: "assignedAgents",
							},
						]}
						items={partnerAgentAssignmentsByLockersData}
						handleAddAgentClick={(data) => {
							console.log({
								operatorId: searchData.operatorId,
								partnerId: searchData.partnerId,
								partnerBranchId: searchData.partnerBranchId,
							});
							let assignedAgents = data.assignedAgents;
							dispatch(
								handleAddPartnerAgentAssignmentData({
									name: "partnerBranchAssignmentId",
									value: data.partnerBranchAssignmentId,
								})
							);
							getAgentsByPartnerAndBranch({
								variables: {
									operatorId: searchData.operatorId,
									partnerId: searchData.partnerId,
									partnerBranchId: searchData.partnerBranchId,
								},
							}).then((data) => {
								if (data.data.agentsWithFilter) {
									let tempVar = [];
									data.data.agentsWithFilter.map((element) => {
										if (
											assignedAgents &&
											assignedAgents.find(
												(x) => x.partnerAgentId === element.partnerAgentId
											) === undefined
										) {
											tempVar.push({
												id: element.partnerAgentId,
												text:
													!element.firstName &&
													!element.middleName &&
													!element.lastName
														? "Unspecified name"
														: `${
																element.lastName ? element.lastName + "," : ""
														  } ${element.firstName ? element.firstName : ""} ${
																element.middleName ? element.middleName : ""
														  } `,
												checked: false,
											});
										}
									});
									dispatch(getAgentList(tempVar));
								}
							});
							setAddAgentModal(true);
						}}
						onDelete={(event, data) => {
							console.log(data);
							setValidation({
								icon: `${process.env.PUBLIC_URL}/assets/images/error.png`,
								title: "Unassign Agent",
								message: "Are you sure you want to remove this assigned agent?",
								open: true,
								header: {
									event: event,
									partnerAgentAssignmentId: data,
								},
							});
						}}
					/>
				)
			) : (
				<></>
			)}
			{/* Modal for removing confirmation */}
			<Dialog
				visible={addAgentModal}
				onHide={() => setAddAgentModal(false)}
				header="Select agent to assign"
			>
				<div style={{ maxHeight: "300px", overflowY: "auto" }}>
					{/* <VerticalRadioButtonList
						dataItems={agentList}
						handleChange={(data) => {
							dispatch(
								handleAddPartnerAgentAssignmentData({
									name: "partnerAgentId",
									value: data,
								})
							);
						}}
					/> */}
					<VerticalCheckboxList
						dataItems={agentList}
						handleOnChange={(data) => {
							let selectedAgent = data.target.value.filter(
								(x) => x.checked === true
							)
								? data.target.value.filter((x) => x.checked === true)
								: [];
							dispatch(
								handleAddPartnerAgentAssignmentData({
									name: "partnerAgentId",
									value: selectedAgent,
								})
							);
						}}
					/>
				</div>
				<hr className="mb-6 mt-2"></hr>
				<p
					className={`text-red-800 my-2 ${
						addAgentValidation ? "block" : "hidden"
					}`}
				>
					Please select one or more agent to assign.
				</p>
				<div className="grid grid-cols-2 gap-2">
					<Button
						onClick={() => {
							setAddAgentModal(false);
						}}
						value={"Cancel"}
						className={"p-2"}
					/>
					<Button
						onClick={handleAddPartnerAgentAssignment}
						value={"Save"}
						className={"p-2"}
					/>
				</div>
			</Dialog>

			{/* Modal for Error Vaidation */}
			<Modal
				icon={validation.icon}
				title={validation.title}
				message={validation.message}
				open={validation.open}
				actions={
					<div className="grid grid-cols-2 gap-2">
						<Button
							onClick={() => {
								setValidation((prev) => ({
									...prev,
									open: false,
								}));
							}}
							value={"No"}
							className={"p-2"}
						/>
						<Button
							onClick={handleDeleteAgentAssignment}
							value={"Yes"}
							className={"p-2"}
						/>
					</div>
				}
			/>
			<Modal
				icon={errorValidation.icon}
				title={errorValidation.title}
				message={errorValidation.message}
				open={errorValidation.open}
				actions={
					<div className="grid grid-cols-1 gap-2">
						<Button
							onClick={() => {
								setErrorValidation((prev) => ({
									...prev,
									open: false,
								}));
							}}
							value={"OK"}
							className={"p-2"}
						/>
					</div>
				}
			/>
		</ContentContainer>
	);
}
